import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getStaffEquipmentsService, createEquipmentService, updateEquipmentsService } from "_services/timeline-service";

const initialState = {
    vehicleList: [],
    wheelChairList: [],
    status: "idle",
    error: null,
}

export const getStaffEquipments = createAsyncThunk(
    "staffEquipments/getStaffEquipmentsService",
    async (params) => {
        return getStaffEquipmentsService(params);
    }
);
export const createEquipment = createAsyncThunk(
    "staffEquipments/createEquipment",
    async (params) => {
        console.log('params', params);
        return createEquipmentService(params);
    }
);
export const updateEquipments = createAsyncThunk(
    "staffEquipments/updateEquipments",
    async (params) => {
        return updateEquipmentsService(params);
    }
);

const staffEquipmentsSlice = createSlice({
    name: "staffEquipments",
    initialState,
    reducers: {
        reset: (state) => initialState,
        resetStatus: (state) => {
            state.status = "idle";
        },
    },
    extraReducers: {
        [getStaffEquipments.pending]: (state, action) => {
            state.status = "loading";
        },
        [getStaffEquipments.fulfilled]: (state, action) => {
            state.status = "succeeded";
            state.vehicleList = action.payload.vehicleList || [];
            state.wheelChairList = action.payload.wheelchairList || [];
        },
        [getStaffEquipments.rejected]: (state, action) => {
            state.status = "failed";
            state.error = action.error.message;
        },
        [createEquipment.pending]: (state, action) => {
            state.status = "loading";
        },
        [createEquipment.fulfilled]: (state, action) => {
            state.status = "succeeded";
        },
        [createEquipment.rejected]: (state, action) => {
            state.status = "failed";
            state.error = action.error.message;
        },
        [updateEquipments.pending]: (state, action) => {
            state.status = "loading";
        },
        [updateEquipments.fulfilled]: (state, action) => {
            state.status = "succeeded";
        },
        [updateEquipments.rejected]: (state, action) => {
            state.status = "failed";
            state.error = action.error.message;
        },

    }
})

export const { resetStatus, reset } = staffEquipmentsSlice.actions;

export const selectStaffEquipments = (state) => {
    const staffEquipments = {
        vehicleList: state.staffEquipments.vehicleList || [],
        wheelChairList: state.staffEquipments.wheelChairList || [],
    }
    return staffEquipments
}
export const selectStaffEquipmentsStatus = state => state.staffEquipments.status

export default staffEquipmentsSlice.reducer;
